import { useQuery } from '@tanstack/react-query';
import { api } from '../../../singleton/axios';

interface HouseLatest {
  symbol: string;
  disclosureDate: string;
  transactionDate: string;
  firstName: string;
  lastName: string;
  office: string;
  district: string;
  owner: string;
  assetDescription: string;
  assetType: string;
  type: string;
  amount: string;
  capitalGainsOver200USD: string;
  comment: string;
  link: string;
}

interface HouseLatestResponse {
  data: HouseLatest[];
  pagination: {
    page: number;
    limit: number;
    count: number;
    hasNextPage: boolean;
  };
}

interface UseHouseLatestParams {
  page?: number;
  limit?: number;
  enabled?: boolean;
}

export const useHouseLatest = ({ page = 0, limit = 100, enabled = true }: UseHouseLatestParams = {}) => {
  return useQuery({
    queryKey: ['house-latest', page, limit],
    queryFn: async (): Promise<HouseLatestResponse> => {
      const response = await api.get('/house-latest', {
        params: { page, limit },
      });
      return response.data;
    },
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes - fresher data for better UX
    refetchOnWindowFocus: false,
  });
};

export type { HouseLatest, HouseLatestResponse };